




































































































import { Component, Vue, Provide } from "vue-property-decorator";
import { configuration } from "@/config/host.config";
import { IConfigurationTV } from "@/@types/filoxenia-config/tv-config";
import { BModal } from "bootstrap-vue";

import BackgroundConfig from "@/components/apps-configuration/tv/bacground-config.vue";
import LogoConfig from "@/components/apps-configuration/tv/logo-config.vue";
import NavConfigurationModal from "@/components/apps-configuration/nav20/nav-configuration-modal.vue";
import OnlineNavigationConfiguration from "@/components/apps-configuration/tv/online-navigation-configuration.vue";
import StandartSwitch from "@/components/app/switchs/standart-switch.vue";
import CinemaPlayerType from "./tv/cinema-player-type.vue";

@Component({
  name: "tv-configuration",
  components: {
    BackgroundConfig,
    LogoConfig,
    NavConfigurationModal,
    "online-nav": OnlineNavigationConfiguration,
    "s-switch": StandartSwitch,
    CinemaPlayerType,
  },
})
class TvConfiguration extends Vue {
  @Provide() backgroundFolder = "main/configuration/background";
  @Provide() logoFolder = "main/configuration/logo";
  optionList = ["nav"];
  rootOptionList = ["online-nav", "cinema-type"];

  background = "";
  logo = "";
  weather_phenomena = false;
  tv_hello = false;

  showBackgroundForm = false;
  showLogoForm = false;
  config: IConfigurationTV | null = null;
  cinema_viode_player_type = "";

  $refs!: {
    navmodal: BModal;
  };

  get logoAccess(): boolean {
    return process.env.VUE_APP_CHANGE_LOGO ? true : this.$getRootPermition();
  }

  getOptionIcon(opt: string): string {
    const icons: Record<string, string> = {
      nav: "layout-text-window-reverse",
      "online-nav": "signpost",
      "cinema-type": "film",
    };
    return icons[opt] || "gear";
  }

  async updateConfig(data: Partial<IConfigurationTV>): Promise<void> {
    try {
      const config = { params: { app: "tv" } };
      const configRes = await this.$axios.put(
        configuration.mainAPI,
        data,
        config
      );
      if (configRes.status === 200) {
        this.$notify({
          group: "global",
          text: String(this.$i18n.t("error.200")),
        });
        this.createConfiguration();
      } else
        this.$notify({
          group: "global",
          text: String(this.$i18n.t("alerts.emptyUpdate")),
          type: "warn",
        });
    } catch (error) {
      console.log(error);
    }
  }

  createConfigParams(data: IConfigurationTV): void {
    this.background = data.background;
    this.logo = data.logo;
    this.config = data;
    this.weather_phenomena = data.weather_phenomena ? true : false;
    this.tv_hello = data.tv_hello ? true : false;
    this.cinema_viode_player_type = data.cinema_viode_player_type
      ? data.cinema_viode_player_type
      : "";
  }

  async createConfiguration(): Promise<void> {
    try {
      const config = { params: { "match[app]": "tv" } };
      const configRes = await this.$axios.get(configuration.mainAPI, config);
      if (configRes.status === 200) {
        this.createConfigParams(configRes.data.configurationtv);
      }
    } catch (error) {
      console.log(error);
    }
  }

  mounted(): void {
    this.createConfiguration();
  }
}
export default TvConfiguration;
